// @ts-nocheck
/* eslint-disable */
export const appFile24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M13 9V3L19 9H13Z" fill="currentColor"/><path d="M13 3H14L19 8V9M13 3H5V21H19V9M13 3V9H19" stroke="currentColor" stroke-width="2"/><path d="M8 13H16" stroke="currentColor" stroke-width="2"/><path opacity="0.5" d="M8 17H16" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'file-24' as const
};